import { CURRENCIES } from '@fortem-monorepo/constants'
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@fortem-monorepo/react-ui'

import { useFundsContext } from '@/pages/funds/funds-context.context'

export interface AddFundEntryModalProps {}

export const AddFundEntryModal: React.FC<AddFundEntryModalProps> = ({}) => {
  const context = useFundsContext()

  return (
    <Dialog
      open={context.newEntry !== null}
      onOpenChange={(open) => {
        if (!open) {
          context.setNewEntry(null)
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add a Funds Entry</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label className="">Type</Label>
            <Select>
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Select a Type" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectItem value="fund">Fund</SelectItem>
                  <SelectItem value="shareclass">Shareclass</SelectItem>
                  <SelectItem value="bucket">Bucket</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label className="">Currency</Label>
            <Select>
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Select a Currency" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {Object.entries(CURRENCIES).map(([, currency]) => (
                    <SelectItem key={currency} value={currency}>
                      {currency}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label className="">Name</Label>
            <Input id="name" defaultValue={context.newEntry?.name} className="col-span-3" />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label className="">Long Name</Label>
            <Input id="longName" defaultValue={context.newEntry?.longName} className="col-span-3" />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label className="">Platform</Label>
            <Input id="platform" defaultValue={context.newEntry?.platform} className="col-span-3" />
          </div>
        </div>
        <DialogFooter>
          <Button
            onClick={() => {
              context.setNewEntry(null)
            }}
            variant={'destructive'}
          >
            Cancel
          </Button>
          <Button type="submit">Save changes</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
